/*
 * @Author: Teemo Ding
 * @Date: 2022-03-01 15:49:18
 * @LastEditTime: 2022-05-05 16:03:00
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/auditTrail/communication.ts
 */
import { get, post } from 'src/tools/server';

export const communicationSearch = (startIndex, batchSize, data) => {
  return post<any>(
    `/portal/communication/log/${startIndex}/${batchSize}`,
    data,
    {},
  );
};

export const communicationInit = (startIndex, batchSize, data) => {
  return post<any>(
    `portal/communication/logsPage/${startIndex}/${batchSize}`,
    data,
    {},
  );
};
export const getCommunicationDetail = (logUuid) => {
  return get<any>(`/portal/communication/log/${logUuid}`, {});
};

export const exportCommunication = (data) => {
  return post<any>(`/portal/communication/log/export`, data, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};
